// @core/api/endpoints/fiscalization/list_fiscal_policies.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListFiscalPoliciesResponse,
} from '../../../types/fiscalization';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/fiscalization';

/**
 * List fiscal policies
 * Returns fiscal policies, optionally filtered by scope entity type.
 */
export async function ListFiscalPolicies(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListFiscalPoliciesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/fiscal-policies`;
  const requestOptions = options;
  return client.get<ListFiscalPoliciesResponse>(requestPath, { ...requestOptions, params });
}
